/**
 * 图片上传
 * 2019-05-28 chenxiaojian
 */
import React from 'react';
import { Icon } from 'antd';

import '../../style/common/uploadImage.css';

import http from '../../axios/http';
import ImageView from './ImageView';

import {getBase64} from '../../util/util.js';

class Image extends React.Component {

    state = {
        image: null,
        previewVisible: false,
        previewImage: null,
        bigsize: 1,
        rotateDeg: 0,
    }

    clickUpload = (e) => {
        let fileInput = this.refs.fileInput;
        fileInput.click();
    }

    uploadImage = (e) => {
        let files = e.target.files;
        if (files.length === 1) {
            this.handleImageUpload(files[0]);
        }
        else {
            this.handleMultipleUpload(files);
        }
    }
    handleImageUpload = async file => {
        await getBase64(file).then(base64 => {
            if (this.props.onChange) {
                this.props.onChange({ base64, file });
            }
            this.setState({ image: base64 });
            this.refs.fileInput.value = '';
        });
    }

    handleMultipleUpload = files => {
        let base64Images = [];
        let length = files.length;
        for (let i = 0; i < length; i++) {
            let file = files[i];
            getBase64(file).then(base64 => {
                base64Images.push(base64);
                if (this.props.onChange && base64Images.length === length) {
                    this.props.onMultipleChange({base64Images});
                }
                if (i === 0) {
                    this.setState({ image: base64 });
                    this.refs.fileInput.value = '';
                }
            });
        }
    }

    handleImagePreview = () => {
        const { file, url } = this.props;
        if (url == null || url === "") {
            this.setState({
                previewImage: file,
                previewVisible: true,
            });
            return ;
        }
        let postUrl = '/common/getWatermarkImage';
        if(this.props.original){
            postUrl = '/common/getOriginalImage';
        }
        //因为现在展示的是缩略图，所以要从服务器上再下载水印图展示
        http.post({
            url: postUrl,
            data: { url: url },
            success: (res) => {
                let f = file;
                if (res != null && res !== "") {
                    f = "data:image/jpeg;base64," + res;
                }
                this.setState({
                    previewImage: f,
                    previewVisible: true,
                });
            }
        });

    }
    handleCancel = () => {
        this.setState({ previewVisible: false })
    };

    handleImageRemove = () => {
        this.refs.fileInput.value = '';
        this.setState({ image: null });
        if (this.props.onRemove) {
            this.props.onRemove();
        }
    }

    // handleClear = () => {
    //     this.refs.fileInput.value = '';
    //     this.setState({image: null});
    // }

    render() {
        const { text, file, type, onlyView } = this.props;
    
        let flag = (file == null || file === "");
        let align = type === 'button' ? "left" : "center";
        return (
            <div> 
                <div className={type === 'button' ? '' : "def-picture-card"} >
                    <div hidden={!flag} style={{ verticalAlign: "middle", textAlign: align, display: flag ? '' : "none" }}>
                        {onlyView === true ? null :
                            <div>
                                <Icon type="camera" style={{ fontSize: '28px', margin: '5px', color: '#19be6b', cursor: 'pointer' }} onClick={this.props.openScanner} />
                                <Icon type="picture" style={{ fontSize: '28px', margin: '5px', color: '#40a9ff', cursor: 'pointer' }} onClick={this.clickUpload.bind(this)} />
                                <input type="file" multiple={this.props.multiple} accept="image/jpg,image/jpeg,image/png" onChange={this.uploadImage.bind(this)} style={{ display: "none" }} ref="fileInput" />
                            </div>
                        }
                        <span>{text}</span>
                    </div>
                    <div className="def-upload-item-info" style={{ display: flag ? "none" : '' }}>
                        <img alt="" src={file}></img>
                    </div>
                    <span className="def-upload-item-actions" style={{ display: flag ? "none" : '' }}>
                        <Icon type="eye" onClick={this.handleImagePreview} />
                        {onlyView === true ? null :
                            <Icon type="delete" onClick={this.handleImageRemove} />
                        }
                    </span>
                </div>
                <ImageView src={this.state.previewImage} visible={this.state.previewVisible} handleCancel={this.handleCancel}/>
                
            </div>
        );
    }
}

export default Image;